"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var template_checkbox_tree_component_1 = __importDefault(require("../template-checkbox-tree/template-checkbox-tree.component"));

var dental_template_checkbox_tree_data_1 = require("./dental-template-checkbox-tree.data");

var DentalTemplateCheckboxTree = function DentalTemplateCheckboxTree(_ref) {
  var onCheckedChange = _ref.onCheckedChange;
  return react_1.default.createElement(template_checkbox_tree_component_1.default, {
    checkBoxNodes: dental_template_checkbox_tree_data_1.DENTAL_CHECKBOX_NODES,
    onCheckedChange: onCheckedChange
  });
};

exports.default = DentalTemplateCheckboxTree;